import { render, staticRenderFns } from "./UiSimpleFiles.vue?vue&type=template&id=7e2dfb0d&lang=pug&"
import script from "./UiSimpleFiles.vue?vue&type=script&lang=js&"
export * from "./UiSimpleFiles.vue?vue&type=script&lang=js&"
import style0 from "./UiSimpleFiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports